module.exports = __webpack_public_path__ + "static/media/uzer-logo-black.768489ec.svg";